import { nowUtcIso } from '@/lib/dates'
import { newUuid } from '@/offline/queue'
import type { Expense } from '@/offline/types'

export interface ExpenseInput {
  workspace_id: string
  amount_paisa: number
  category_id?: string | null
  note?: string | null
  spent_at?: string
}

export interface BuiltExpense {
  expense: Expense
  payload: Record<string, unknown>
}

export function buildExpense(input: ExpenseInput): BuiltExpense {
  const now = nowUtcIso()
  const expense: Expense = {
    workspace_id: input.workspace_id,
    id: newUuid(),
    category_id: input.category_id ?? null,
    amount_paisa: input.amount_paisa,
    spent_at: input.spent_at ?? now,
    note: input.note ?? null,
    revision: 1,
    created_at: now,
    updated_at: now,
    deleted_at: null,
  }
  const payload: Record<string, unknown> = {
    amount_paisa: expense.amount_paisa,
    category_id: expense.category_id,
    note: expense.note,
    spent_at: expense.spent_at,
  }
  return { expense, payload }
}
